// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.admin-dashboard {
    background-color: #f8f9fa;
    padding: 5px;
    border-radius: 8px;
  }
  .dashboard-header {
    background-size: cover;
    background-position: center;
    padding: 20px;
    border-radius: 8px;
  }

  .dashboard-header1 {
    background-size: cover;
    background-position: center;
    padding: 40px;
    border-radius: 8px;
  }
  .admin-dashboard h4 {
    color: #007bff;
  }
  
  .admin-dashboard .nav-tabs .nav-link.active {
    background-color: #E10174;
    color: white;
  }
  
  .admin-dashboard .nav-tabs .nav-link {
    color: #007bff;
  }
  
  .admin-dashboard .tab-content {
    background-color: white;
    border: 1px solid #dee2e6;
    border-top: none;
    border-radius: 0 0 8px 8px;
  }`, "",{"version":3,"sources":["webpack://./src/Styles/AdminDashboard.css"],"names":[],"mappings":"AAAA;IACI,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,2BAA2B;IAC3B,aAAa;IACb,kBAAkB;EACpB;EACA;IACE,cAAc;EAChB;;EAEA;IACE,yBAAyB;IACzB,YAAY;EACd;;EAEA;IACE,cAAc;EAChB;;EAEA;IACE,uBAAuB;IACvB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;EAC5B","sourcesContent":[".admin-dashboard {\n    background-color: #f8f9fa;\n    padding: 5px;\n    border-radius: 8px;\n  }\n  .dashboard-header {\n    background-size: cover;\n    background-position: center;\n    padding: 20px;\n    border-radius: 8px;\n  }\n\n  .dashboard-header1 {\n    background-size: cover;\n    background-position: center;\n    padding: 40px;\n    border-radius: 8px;\n  }\n  .admin-dashboard h4 {\n    color: #007bff;\n  }\n  \n  .admin-dashboard .nav-tabs .nav-link.active {\n    background-color: #E10174;\n    color: white;\n  }\n  \n  .admin-dashboard .nav-tabs .nav-link {\n    color: #007bff;\n  }\n  \n  .admin-dashboard .tab-content {\n    background-color: white;\n    border: 1px solid #dee2e6;\n    border-top: none;\n    border-radius: 0 0 8px 8px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
